// extracted by mini-css-extract-plugin
export default {"title":"views-CheckoutPage-ContactInfo-themes-BGH-RD3-deliveryForm__title--Cfxvp","disclaimer":"views-CheckoutPage-ContactInfo-themes-BGH-RD3-deliveryForm__disclaimer--XriA3"};